import React, { useEffect } from 'react';
import { Link } from '@reach/router';

import {
  MessagesProvider,
  Message,
  useLocale,
} from '../../../../modules/Internationalization';

import {
  Container,
  Grid,
  GridCol,
  Section,
  Bar,
  BarItem,
} from '../../../../components/';

import messages from './messages';
import './style.scss';
import { urlify, localizeUrl } from '../utils';

const categories = [
  'all',
  'articles',
  'podcasts',
  'showcases',
  'videos',
  // 'events',
];

const Categories = ({ children }) => {
  useEffect(() => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  });

  const locale = useLocale();

  return (
    <MessagesProvider messages={messages}>
      <Container>
        <Grid>
          <GridCol offset={{ l: 6 }}>
            <h1 className="h2 font-family-clearface">
              <Message id="title" />
            </h1>
            <Section space="none">
              <Bar className="mb-small">
                {categories.map(category => {
                  const url = (() => {
                    if (
                      messages[category][locale] === 'All' ||
                      messages[category][locale] === 'Všetko'
                    ) {
                      return localizeUrl('/blog', locale);
                    }

                    return localizeUrl(
                      `/blog/_/${urlify(messages[category][locale])}`,
                      locale
                    );
                  })();

                  return (
                    <BarItem key={category} className="category">
                      <h6>
                        <Link
                          to={url}
                          getProps={({ isCurrent }) => ({
                            className: isCurrent ? 'active' : 'inactive',
                          })}
                        >
                          <Message id={category} />
                        </Link>
                      </h6>
                    </BarItem>
                  );
                })}
              </Bar>
            </Section>
          </GridCol>
        </Grid>
        <Grid>
          <GridCol offset={{ l: 6 }}>{children}</GridCol>
        </Grid>
      </Container>
    </MessagesProvider>
  );
};

export default Categories;



// WEBPACK FOOTER //
// ./src/scripts/modules/Insights/Categories/index.js